import { withStyles } from '@mui/styles';
import { Tabs as MuiTabs } from '@mui/material';

const styles = () => ({
    tabs: {
        minHeight: 'initial',
        '& .MuiTabScrollButton-root': {
            opacity: 0.9,
            transition: 'opacity 0.3s ease, width 0.3s ease',
            '&.Mui-disabled': { opacity: 0.2 },
            '&:first-of-type.Mui-disabled': { width: 0 }, // hide the left scroll button when disabled
        },
    },
});

function Tabs({ children, value, onChange, ariaLabel, classes, ...other }) {
    return (
        <MuiTabs
            value={value}
            onChange={onChange}
            aria-label={ariaLabel}
            className={classes.tabs}
            indicatorColor="transparent"
            variant="scrollable"
            scrollButtons="auto"
            {...other}
        >
            {children}
        </MuiTabs>
    );
}

export default withStyles(styles)(Tabs);
